<section class="dynamic-system">
    <section class="dynamic-collapse-header">
        <div class="data-info">
            <h3>Annual Property Income vs Expenses</h3>
            <!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="" ngbTooltip="Hover over chart to see values."
                placement="top"> -->
            <div class="svg-container help-btn-svg-container" ngbTooltip="Hover over chart to see values."
            placement="top">
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 832.46 905"
                    width="30px">
                    
                    <path
                        d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
                        transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
                    <path
                        d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
                        transform="translate(-95.77 -59.5)" fill="#fff" />
                    <path
                        d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
                        transform="translate(-95.77 -59.5)" class="svg-sign" />
                    <path
                        d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
                        transform="translate(-95.77 -59.5)" class="svg-sign" />
                </svg>
            </div>
        </div>
    </section>

    <section class="dynamic-collapse-main">
        <section class="dynamic-collapse-content">
            <section class="section-graph">
                <div *ngIf="income>0" class="income-graph-section" [style.height]="barHeightText"
                    ngbTooltip="Income {{income | currency:'GBP':'symbol-narrow':'1.0'}}" placement="right">
                    <div class="income-graph-container">
                        <div class="income-graph" [style.height]="incomeHeight">Rent</div>
                    </div>
                    <div class="basis-data">Income {{income | currency:'GBP':'symbol-narrow':'1.0'}}</div>
                </div>
                <div class="test">
                    <div class="expenses-graph" [style.height]="barHeightText">
                        <div *ngFor="let expense of expenses;">
                            <div class="expense-graph" id="{{expense.id}}" [style.height]="expense.height"
                                ngbTooltip="{{expense.name}} {{expense.amount| currency:'GBP':'symbol-narrow':'1.0'}}"
                                placement="right">
                                <span *ngIf="expense.height == '3px'">&nbsp;</span><span
                                    *ngIf="expense.height != '3px'">{{expense.name}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="basis-data">Expenses {{netIncome | currency:'GBP':'symbol-narrow':'1.0'}}</div>
                </div>
                <div *ngIf="income>0" class="income-graph-section" [style.height]="barHeightText"
                    ngbTooltip="Net Income {{netIncome| currency:'GBP':'symbol-narrow':'1.0'}}" placement="right">
                    <div class="income-graph-container">
                        <div class="income-graph net-income-graph" [style.height]="netIncomeHeight">Net<br>Income</div>
                    </div>
                    <div class="basis-data">Net Income {{netIncome | currency:'GBP':'symbol-narrow':'1.0'}}</div>
                </div>
            </section>
        </section>
    </section>
</section>